import React from 'react';
import { Redirect } from 'react-router-dom';
import { getData } from '../utils/sessionStorage';
import { AppConstants } from '../utils/constants';

const SlowEnrollmentRedirect = () => {
  const currentPage = getData(AppConstants.currentPage) || 1;

  return <Redirect to={`/s/${currentPage}`} />;
};

export default SlowEnrollmentRedirect;
